import { FeatureFlagSet } from '@/featureFlags';
import { UrlEnvironmentType } from '@/typings/url';

/**
 * Encapsulate the logic for determining if a model query history is supported by the adapter
 * Centralizing this logic since it will be updated as model query history support is added to other adapters
 */
export const modelQueryHistorySupported = (
  adapter: string,
  environmentType: UrlEnvironmentType,
  featureFlags?: FeatureFlagSet,
) => {
  if (environmentType !== 'production') {
    return false;
  }
  if (adapter === 'bigquery' || adapter === 'snowflake') {
    return true;
  }
  if (adapter === 'redshift') {
    return featureFlags?.meta6609RedshiftQueryHistory === true;
  }
  if (adapter === 'databricks') {
    return featureFlags?.meta6610DatabricksQueryHistory === true;
  }
  return false;
};
